module.exports = __webpack_public_path__ + "static/Highlight7-ee161de428e2ca7ee72562bc3eda57b3.png";